<template>
  <div>
    <login-modal-component />
    <div class="p-6 md:p-0 md:pt-6">
      <div class="flex items-center justify-center md:justify-between mb-6">
        <img
          class="md:hidden block w-12"
          src="/img/logo-yuk-belajar.png"
          alt="Yuk Belajar">
        <h1 class="hidden md:block font-semibold text-xl text-blue-900">
          Pembayaran
        </h1>
      </div>
      <div class="flex flex-wrap items-stretch justify-between">
        <pending-transaction
          v-for="transaction in $store.state.pendingTransactions"
          :id="transaction.id"
          :key="transaction.id" />
        <div
          v-if="!totalAmount && !totalPendingTransactions"
          class="px-3 py-8 w-full bg-gray-100 rounded-lg text-gray-900 text-center">
          <div class="text-sm leading-relaxed mb-10">
            Tidak ada pembayaran apapun di sini.
          </div>
          <a
            href="/products"
            class="bg-orange-500 text-white font-bold rounded p-3 text-sm focus:outline-none active:bg-orange-400"
            @click="$store.commit('setLoading', true)">Beli Tiket</a>
        </div>
        <div
          v-if="totalAmount"
          class="w-full">
          <button
            v-if="!inputVoucherOpen && validDate()"
            class="focus:outline-none px-3 py-3 mb-3 w-full rounded-lg text-orange-800 bg-orange-300 font-bold text-center"
            @click="openInputVoucher()">
            Gunakan kode voucher
          </button>
          <div
            v-if="inputVoucherOpen && voucherValidation !== true"
            class="mb-3 px-3 py-3 w-full bg-gray-100 rounded-lg text-gray-900 text-center">
            <div class="w-full text-left text-gray-700 text-sm">
              Kode Voucher
            </div>
            <div class="flex items-center justify-between mb-1">
              <input
                v-model="voucher"
                :class="{
                  'border-red-400' : voucherValidation === false,
                }"
                class="font-semibold uppercase w-full block focus:border-green-400 focus:outline-none bg-transparent border-b md:text-base py-2"
                type="email"
                @focus="resetVoucherValidation()">
              <div class="w-5 h-3" />
              <button
                class="w-32 text-xs px-3 py-2 rounded bg-green-600 text-gray-100 focus:outline-none"
                @click="checkVoucher()">
                Gunakan
              </button>
            </div>
            <div
              v-if="voucherValidation === false"
              class="w-full text-left text-red-400 text-sm">
              Kode voucher tidak valid
            </div>
          </div>
          <div
            v-if="voucherValidation === true"
            class="focus:outline-none px-3 py-3 mb-3 w-full rounded-lg shadow text-green-800 bg-green-300 font-bold text-center">
            Dapatkan diskon Rp5.000 per orang, minimal daftar kolektif 5 orang.
          </div>
          <cart-item
            v-for="userProduct in $store.state.userProducts"
            :id="userProduct.id"
            :key="userProduct.id"
            class="mb-3"
            :name="userProduct.product.name"
            :minimum_purchase="userProduct.product.minimum_purchase"
            :maximum_purchase="userProduct.product.maximum_purchase"
            :cart_discount="userProduct.product.cart_discount"
            :price="userProduct.product.price" />
        </div>

        <div
          v-if="totalAmount"
          class="px-3 py-2 md:py-4 w-full md:rounded-lg bg-gray-100 md:shadow text-gray-700 fixed left-0 md:static"
          style="bottom: 52px;">
          <div class="flex items-center justify-between">
            <div>
              <div class="w-full font-bold mb-1 md:mb-2 text-xs md:text-base">
                Total Harga
                <span
                  v-if="totalDiscount > 0"
                  class="text-gray-500">+ Yeyyy kamu dapet diskon : {{ $rupiah(totalDiscount) }}</span>
              </div>
              <div class="font-bold text-md md:text-lg text-orange-600">
                {{ $rupiah(totalPrice) }}
              </div>
            </div>
            <button
              :disabled="$store.state.loading"
              class="w-32 md:flex-none rounded-lg p-3 bg-orange-600 text-white font-bold text-sm md:text-lg focus:outline-none active:bg-orange-500 disabled:cursor-not-allowed disabled:opacity-75"
              @click="pay()">
              Bayar ({{ totalAmount }})
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: [],
  data: function() {
    return {
      voucher: '',
      inputVoucherOpen: false,
      voucherValidation: null,
    };
  },
  computed: {
    totalPrice() {
      let totalPrice = this.$store.getters.userProductTotalPrice;
      totalPrice -= this.totalDiscount;
      return totalPrice;
    },
    totalDiscount() {
      if (this.totalAmount > 1) {
        return this.$store.getters.userProductTotalDiscPrice;
      }
      return 0;
    },
    totalAmount() {
      return this.$store.getters.userProductTotalAmount;
    },
    totalPendingTransactions() {
      return this.$store.getters.pendingTransactionsTotal;
    },
  },
  async mounted() {
    this.$store.commit('setLoading', true);
    this.$store.commit('setCurrentPath', 'cart');
    try {
      await this.$store.dispatch('loadCities');
      await this.$store.dispatch('loadMajors');
    } catch (error) {
      this.$store.commit('setLoading', false);
      throw error;
    }
    this.$store.commit('setLoading', false);
  },
  methods: {
    resetVoucherValidation() {
      this.voucherValidation = null;
      this.voucher = '';
    },
    openInputVoucher() {
      this.inputVoucherOpen = true;
    },
    validDate() {
      let now = new Date();
      let lowest = new Date('2020-03-11T00:00:00+07:00');
      let highest = new Date('2020-03-12T23:59:00+07:00');
      return now.getTime() >= lowest.getTime() && now.getTime() <= highest.getTime();
    },
    checkVoucher() {
      let voucher = this.voucher;
      if (voucher.toUpperCase() == 'YUKBELAJARCERIA' && this.validDate()) {
        this.voucherValidation = true;
        this.$store.commit('setVoucher', this.voucher);
      } else {
        this.voucherValidation = false;
      }
    },
    async pay() {
      this.$store.commit('setLoading', true);
      try {
        var response = await this.$store.dispatch('pay');
        this.$store.commit('setLoading', false);
        window.location.href = response.data;
      } catch (error) {
        if (error.response.status == 422) {
          this.$store.commit('setErrors', error.response.data.errors);
        } else {
          this.$store.commit('setLoading', false);
          throw error;
        }
      }
      this.$store.commit('setLoading', false);
    },
  },
}
</script>
